import React,{ Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Button from '../../../shared/components/Button';
import AudienceBarChart from './AudienceBarChart';
import Link from 'react-router-dom/NavLink'

import { urlRoot } from '../../../shared/utils';

class DabblAudience extends Component {
  render(){
    return (
      <div className='DabblAudience'>
        <Container>
          <Row>
            <Col xs='12'>
              <br />
              <div className='SectionLabel'>THE BASICS</div>
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='12' sm='6' md='4'>
              <AudienceBarChart
                title='Gender'
                labels={['Female','Male']}
                values={[90,10]}
              />
              <br />
            </Col>
            <Col xs='12' sm='6' md='4'>
              <AudienceBarChart
                title='Age'
                labels={['Gen Z','Millenials','Gen X','Boomers']}
                values={[21,44,23,12]}
              />
              <br />
            </Col>
            <Col xs='12' sm='6' md='4'>
              <AudienceBarChart
                title='Education'
                labels={['College','Other']}
                values={[65,35]}
              />
              <br />
            </Col>
            <Col xs='12' sm='6' md='4'>
              <AudienceBarChart
                title='Relationship status'
                labels={['Single','In a Relationship','Married']}
                values={[29,28,43]}
              />
              <br />
            </Col>
            <Col xs='12' sm='6' md='4'>
              <AudienceBarChart
                title='Mobile OS'
                labels={['iOS','Android']}
                values={[72,28]}
              />
              <br />
            </Col>
            <Col xs='12' sm='6' md='4'>
              <AudienceBarChart
                title='Ad blocker usage'
                labels={['Yes', 'No', "No, but I’d like to"]}
                values={[38,45,17]}
              />
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <br />
              <div className='SectionLabel'>PURCHASE BEHAVIOR</div>
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <AudienceBarChart
                title='I am willing to pay more for a brand I trust'
                labels={['Very Often', 'Often', 'Sometimes', 'Very Rarely']}
                values={[35,40,22,3]}
                wide
              />
              <br />
            </Col>
            <Col xs='12'>
              <AudienceBarChart
                title='Most important to me when making a purchase'
                labels={['Quality', 'Price', 'Reviews']}
                values={[51,32,17]}
                wide
              />
              <br />
            </Col>
            <Col xs='12'>
              <AudienceBarChart
                title='I give product advice and recommendations'
                labels={['Very often', 'Often', 'Sometimes','Rarely']}
                values={[50,31,17,2]}
                wide
              />
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <br />
              <div className='SectionLabel'>LIFESTYLE</div>
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              <AudienceBarChart
                title='What I enjoy most'
                labels={['Doing things with family and friends', 'Shopping', 'Saving money', 'Social media']}
                values={[61,20,13,6]}
                wide
              />
              <br />
            </Col>
            <Col xs='12'>
              <AudienceBarChart
                title='Why I take vacations'
                labels={['Quality time with family and friends', 'Relax', 'Interesting places','Other']}
                values={[43,33,23,1]}
                wide
              />
              <br />
            </Col>
            <Col xs='12'>
              <AudienceBarChart
                title='Dining out'
                labels={['Weekly+', 'Weekly', 'Monthly+','Other']}
                values={[27,38,22,13]}
                wide
              />
              <br />
            </Col>
          </Row>
          <Row>
            <Col xs='12'>
              {/*TRANSPARENT*/}
              <i>This audience data is based on surveys of Downtime Dollars consumers, sample sizes ranging from 1,117 to 6,690 plus internal user data Q1 & Q2 2018.</i>
              <br />
              <br />
              <Card>
                <CardBody>
                  <div style={{marginTop:8,display:'inline-block'}}>
                    Data you’re looking for not here?&nbsp;&nbsp;
                    <Link to={`${urlRoot(this.props.match.url)}/experiences/create/new`}>Setup your own experience</Link>
                    &nbsp;to learn new insights from consumers.
                  </div>
                </CardBody>
              </Card>
              <br />
              <br />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

DabblAudience.propTypes = {
  //TODO: Fill in prop types for DabblAudience
};

DabblAudience.defaultProps = {
  //TODO: Fill in defaultProps for DabblAudience
};

export default DabblAudience;



// WEBPACK FOOTER //
// ./src/routes/DabblAudience/components/DabblAudience.js